module.exports = __webpack_public_path__ + "img/Layout-Kieka-mobile.6a6f7b57.png";